import useDynamicArrayState from './useDynamicArrayState';
import MultiChoiceItem from '../../../types/MultiChoiceItem';
import useDynamicState from './useDynamicState';
import Uuid from '../../../model/Uuid';
import getAllMultichoiceData from '../function/getAllMultichoiceData';

type ReturnType = {
  values: MultiChoiceItem[];
  withoutValue: boolean;
  changeHandler: (items: MultiChoiceItem[]) => void;
  resetValues: () => void;
};

export default (activeItems: Uuid[], allItems: MultiChoiceItem[], withoutValueFromProps: boolean): ReturnType => {
  const activeMultiChoiceItems = getAllMultichoiceData(activeItems, allItems);
  const [values, setValues] = useDynamicArrayState(
    activeMultiChoiceItems.map(el => ((el.id === 'isNepriradeny') ? {
      ...el,
      checked: withoutValueFromProps,
    } : el)),
  );
  const [withoutValue, setWithoutValue] = useDynamicState(withoutValueFromProps);
  const changeHandler = (newValues: MultiChoiceItem[]): void => {
    setValues(newValues);
    setWithoutValue(newValues.find(({ id }) => id === 'isNepriradeny').checked);
  };

  const resetValues = (): void => {
    setValues(allItems);
    setWithoutValue(true);
  };

  return {
    values,
    withoutValue,
    changeHandler,
    resetValues,
  };
};
